import Vue from "vue";
import VueI18n from "vue-i18n";

import en from "vuetify/lib/locale/en";
//import de from "vuetify/lib/locale/de";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const locales = [
  {
    value: "en",
    text: "English",
    dataUrl: "/data/input-data-sentiment-EN.csv",
    sentiments: ["positive", "negative", "neutral", "mixed"]
  }/*,
  {
    value: "de",
    text: "Deutsch",
    dataUrl: "/data/input-data-sentiment-DE.csv",
    sentiments: ["positiv", "negativ", "neutral", "gemischt"]
  }*/
];

const vuetifyLocales = { en };//, de

export { locales, vuetifyLocales };

export default new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: loadLocaleMessages()
});
